import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'app/core/models/user';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private uri: any = environment.protocol + '://' + environment.hostName;

  constructor(
    private http: HttpClient
  ) { }

  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(`${this.uri}/user/get/all`);
  }

  getUsersFilter(data: any): Observable<User[]> {
    return this.http.post<User[]>(`${this.uri}/user/get/filter`, data);
  }

  updateRole(data: any) {
    return this.http.post(`${this.uri}/user/update/role`, data);
  }

}
